import { API_URLS } from "../apiUrls";

export const individualStorePerformanceUnitTestConstants = {
  PAGE_SIZE_TEN: "10",
  PAGE_SIZE_TWENTY: "20",
  DUMMY_SEARCH_VALUE: "Test",
  ASC_NAME_SORTING_CONSTANT: "name asc",
  ALL_TIME_FILTER_QUERY_START_DATE: 1672513200,
  GET_INTERNAL_NOTES_API_PATH:
    API_URLS.SURVEY_INBOX.GET_ALL_CUSTOMER_CONVERSATION_NOTES,
  GET_ALL_USER_RESPONSES_COMMON_API_PATH:
    API_URLS.USER_RESPONSES.GET_ALL_USER_RESPONSES,
  ROUTE_FROM_FR:
    "/redirecting-to-store-profile?locationId=1539&token=ZXlKaGJHY2lPaUpJVXpJMU5pSXNJblI1Y0NJNklrcFhWQ0o5LmV5SndiR0YwWm05eWJXdGxlU0k2SW1aaU1UZzVPVFk0TFdFM1lUa3ROR1pqWXkxaU16WmxMVGc0T1RJNU1UUmtPRFE0WmlJc0lsSnZiR1VpT2lKVGRYQmxja0ZrYldsdUlpd2lhSFIwY0RvdkwzTmphR1Z0WVhNdWJXbGpjbTl6YjJaMExtTnZiUzkzY3k4eU1EQTRMekEyTDJsa1pXNTBhWFI1TDJOc1lXbHRjeTl5YjJ4bElqb2lVM1Z3WlhKQlpHMXBiaUlzSW1wMGFTSTZJamxoWkdGbU5XUXpMVEl4WmpjdE5HTmtZaTFoTm1aaUxXUXlPRGRsTVRJeFlUVTVZeUlzSW1WNGNDSTZNVGN3TkRnMk5EVXlPQ3dpYVhOeklqb2ljM1Z5ZG1WNUxtWjFiSEpoYVd3dVkyOXRJaXdpWVhWa0lqb2ljM1Z5ZG1WNUxtWjFiSEpoYVd3dVkyOXRJbjAuT1BDNmxKTWhsU2N2dGdxeWJYMlhOaWlGcktGN0VCSGdEOXhNeHZfNTJOOA==&fromFR=true",
};
